import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Nullable } from '@velites/common';
import { useAttrs, useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: String,
  },
  type: {
    type: String,
  },
},
  emits: ["update:model-value"],
  setup(__props, { emit }: { emit: ((event: 'update:model-value', value: Nullable<any>) => void), expose: any, slots: any, attrs: any }) {

const props = __props


const slots = useSlots();

const attrs = useAttrs();
const update = (value: string) => {
  const actualValue =
    props.type === 'number'
      ? value?.length > 0
        ? Number(value)
        : undefined
      : value;
  emit('update:model-value', actualValue);
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, _mergeProps(_unref(attrs), {
    type: __props.type,
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:model-value', value)),
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (update(__props.modelValue || '')))
  }), _createSlots({ _: 2 }, [
    (_unref(slots).append)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "append")
          ])
        }
      : undefined
  ]), 1040, ["type", "model-value"]))
}
}

})